module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip"
    }],
    staticClass: "toolbar-btn js-md hidden-xs",
    attrs: {
      "type": "button",
      "tabindex": "-1",
      "data-container": "body",
      "data-md-tag": _vm.tag,
      "data-md-block": _vm.tagBlock,
      "data-md-prepend": _vm.prepend,
      "title": _vm.buttonTitle,
      "aria-label": _vm.buttonTitle
    }
  }, [_c('i', {
    staticClass: "fa fa-fw",
    class: _vm.iconClass,
    attrs: {
      "aria-hidden": "true"
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// /var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-25770372"}!/var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!./vue_shared/components/markdown/toolbar_button.vue
// module id = ../../../node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-25770372"}!../../../node_modules/vue-loader/lib/selector.js?type=template&index=0!./vue_shared/components/markdown/toolbar_button.vue
// module chunks = common_vue